import { useEffect, useMemo } from 'react';
import { reactEvents } from '@bridge/reactEvents';
import { createContextHookValue } from '@texas/utils/contextState';
import { useLocalStorage } from './useLocalStorage';
import {
  HistoryEntry,
  historyStorageKey,
  normalizeHistory,
  recordEntityVisit,
} from './entityHistory';

export const [EntityHistoryProvider, useEntityHistory] = createContextHookValue(
  useEntityHistoryState,
);

function useEntityHistoryState() {
  const [storedHistory, setHistory] = useLocalStorage<HistoryEntry[]>(
    historyStorageKey,
    [],
    undefined,
    Array.isArray,
  );
  const history = useMemo(
    () => normalizeHistory(storedHistory),
    [storedHistory],
  );

  useEffect(() => {
    setHistory(normalizeHistory);
    return reactEvents.entityVisited.subscribe((event) => {
      setHistory((previous) => recordEntityVisit(previous, event));
    });
  }, [setHistory]);

  return history;
}
